module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "mousemove": _vm.mouseover
    }
  }, [_c('g', {
    style: ({
      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
    })
  }, [_c('path', {
    staticClass: "area",
    attrs: {
      "d": _vm.paths.area
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": _vm.paths.line
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "selector",
    attrs: {
      "d": _vm.paths.selector
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a140edc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaChart.vue
// module id = 72
// module chunks = 2